import TableSortIcon from "./TableSortIcon.jsx";
import clickableRowProps from "../../../helpers/a11y/clickableRowProps.js";

const ARIA_SORT = { asc: 'ascending', desc: 'descending' };

/**
 * @param {object} props
 * @param {string} [props.label] - Header text; ignored when `children` is given
 * @param {React.ReactNode} [props.children] - Custom header content
 * @param {string} [props.className]
 * @param {number} [props.colSpan]
 * @param {number} [props.rowSpan]
 * @param {boolean} [props.sortable] - Renders the header as a sort control
 * @param {'asc'|'desc'|null} [props.sortDirection] - Active direction for THIS column
 * @param {() => void} [props.onSort] - Called when the user clicks the sort control
 */
const TableHeadCell = ({
  label,
  children,
  className = '',
  colSpan,
  rowSpan,
  sortable = false,
  sortDirection = null,
  onSort,
}) => {
  const classes = [
    'common-table__head-cell',
    sortable ? 'common-table__head-cell--sortable' : '',
    className,
  ].filter(Boolean).join(' ');

  const content = children || label;

  return (
    <th
      className={classes}
      colSpan={colSpan}
      rowSpan={rowSpan}
      aria-sort={sortable ? (ARIA_SORT[sortDirection] || 'none') : undefined}
    >
      {sortable ? (
        // Geen <button>: binnen een ReadOnlyGuard (<fieldset disabled>) zet de
        // browser die uit, en sorteren wijzigt niets — een lezer hoort het te
        // kunnen. clickableRowProps geeft de rol, de tabstop en Enter/spatie.
        <span className="common-table__sort-button" {...clickableRowProps(onSort)}>
          {content}
          <TableSortIcon direction={sortDirection} />
        </span>
      ) : content}
    </th>
  );
};

export default TableHeadCell;
